import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IdleWarningComponent } from '../components/idle-warning/idle-warning.component';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class TimeoutIdleService {
  readonly timeoutIdle = 60 * 1000 * 60; // 60 minutos
  timeOut: any;
  inverval: any;
  timeAprox;
  dialogRef: MatDialogRef<IdleWarningComponent, any>;

  constructor(
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {
    window.addEventListener('click', () => {
      this.resetTimeoutIdle();
    });
    window.addEventListener('keypress', () => {
      this.resetTimeoutIdle();
    });
    window.addEventListener('scrollEnd', () => {
      this.resetTimeoutIdle();
    });
  }

  startWatching() {
    this.timeAprox = new Date().getTime() + this.timeoutIdle;
    const currentTime = new Date().getTime();
    const timeDifference = this.timeAprox - currentTime;
    const minutesInFuture = timeDifference / (1000 * 60);
    this.timeOut = setTimeout(async () => {
      console.log("TIME OUT IDLE IS TIME")
      if (await this.userService.isUserAvailable()) {
        this.userService.doLogout(true);
        this.dialog.closeAll();
      }
    }, this.timeoutIdle);

    this.setInvervalTime();
  }

  setInvervalTime() {
    this.inverval = setInterval(async () => {
      const timeLeft = this.getTimeLeft();
      if (timeLeft < 33) {
        if (await this.userService.isUserAvailable()) {
          this.dialogRef = this.dialog.open(IdleWarningComponent, {
            width: '500px',
          });
          clearInterval(this.inverval);
        }
      }
    }, 1000 * 30);
  }

  getTimeLeft() {
    let miliseccondsLeft = this.timeAprox - new Date().getTime();
    return miliseccondsLeft / 1000;
  }

  resetTimeoutIdle() {
    clearTimeout(this.timeOut);
    clearInterval(this.inverval);
    this.startWatching();
  }
}
